import Report from "./Report";
import QuestionPicturesReportItem from "./QuestionPicturesReportItem";

export default class FindPicturesReportItemResponse {

    public report: Report | null = null;

    public reportItem: QuestionPicturesReportItem | null = null;
}